<template>
  <div
    class="db-tw-mb-9"
    v-if="options.length"
  >
    <DbSelectCustom
      :modelValue="modelValue"
      :options="optionsWithEmptyValue"
      :class="[{ 'db-has-error': v$.field.$error }]"
      :inputAttrs="{ required: isMandatory }"
      v-on:update:model-value="$emit('update:modelValue', $event)"
    >
      <span class="db-label">{{ label }}</span>
      <template
        v-if="v$.field.$error"
        v-slot:error
      >
        <DbRfpErrors :errors="v$.field.$errors" />
      </template>
    </DbSelectCustom>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import type { Options } from '@/types/components/combobox'
import { useI18n } from 'vue-i18n'
import { requiredIf } from '@/utils/i18n-validators'

const props = withDefaults(
  defineProps<{
    /** Label of the field */
    label: string
    /** Selected value */
    modelValue?: string
    /* Available options inside the field */
    options: Options
    isMandatory: boolean
  }>(),
  {
    modelValue: '',
  },
)

defineEmits<{
  (e: 'update:modelValue', modelValue: string): void
}>()

const { t } = useI18n()
const optionsWithEmptyValue = computed(() => {
  const defaultValue = {
    label: t('Select item'),
    value: '',
  }
  return [defaultValue, ...props.options]
})

const state = computed(() => {
  return {
    field: props.modelValue,
  }
})

const rules = {
  field: { required: requiredIf(props.isMandatory && props.options.length > 0) },
}

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>
